export default __webpack_public_path__ + "static/media/program_intro_15.d3d1120a.png";